import React from "react";
import { ShimmerEffect } from "@/components/ui/shimmerEffect";
import { clsx } from "clsx";

const DriveHeaderSkeleton: React.FC = () => (
  <div className="mb-6 pb-4">
    <div className="mb-2 flex flex-col justify-between space-y-2 sm:flex-row sm:space-y-0">
      <div className="h-8 w-48 rounded bg-gray-200">
        <ShimmerEffect />
      </div>
      <div className="flex space-x-2 sm:space-x-4">
        <div className="h-10 w-24 rounded bg-gray-200">
          <ShimmerEffect />
        </div>
        <div className="h-10 w-24 rounded bg-gray-200">
          <ShimmerEffect />
        </div>
      </div>
    </div>
    <div className="h-6 w-full rounded bg-gray-200">
      <ShimmerEffect />
    </div>
  </div>
);

const DriveSearchSkeleton: React.FC = () => (
  <div className="mb-4 flex items-center">
    <div className="relative flex-grow">
      <div className="h-10 w-full rounded bg-gray-200">
        <ShimmerEffect />
      </div>
    </div>
    <div className="ml-2 h-10 w-24 rounded bg-gray-200">
      <ShimmerEffect />
    </div>
  </div>
);

const DriveRowSkeleton: React.FC = () => (
  <div className="flex flex-col items-start gap-4 p-4 md:flex-row md:items-center md:p-6">
    <div className="w-full md:w-1/2 lg:w-7/12">
      <div className="mb-2 h-6 w-3/4 rounded bg-gray-200">
        <ShimmerEffect />
      </div>
      <div className="h-4 w-1/2 rounded bg-gray-200">
        <ShimmerEffect />
      </div>
    </div>
    <div className="mt-2 flex w-full flex-wrap items-center justify-start gap-2 md:mt-0 md:w-1/2 md:justify-end lg:w-5/12">
      <div className="h-8 w-24 rounded bg-gray-200">
        <ShimmerEffect />
      </div>
      <div className="h-8 w-24 rounded bg-gray-200">
        <ShimmerEffect />
      </div>
      <div className="h-8 w-24 rounded bg-gray-200">
        <ShimmerEffect />
      </div>
    </div>
  </div>
);

interface DriveSkeletonProps {
  className?: string;
  hideHeader?: boolean;
  hideSearch?: boolean;
}
export const DriveSkeleton: React.FC<DriveSkeletonProps> = ({ className = "p-8", hideHeader, hideSearch }) => (
  <div className={clsx("mx-auto", className)}>
    {!hideHeader && <DriveHeaderSkeleton />}
    {!hideSearch && <DriveSearchSkeleton />}
    <div className="divide-y divide-gray-200 rounded-lg bg-white">
      {Array.from({ length: 10 }, (_, index) => (
        <DriveRowSkeleton key={index} />
      ))}
    </div>
  </div>
);
